import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { get } from '../utils';
/**
 * 声明可注入的变量
 * @description
 * 对应 Inject 声明的变量，主要用于缓存需要的流程TOKEN变量；
 */

export var Injectable = function Injectable(variables) {
  return function (_target, _property, descriptor) {
    var noConfilt = descriptor.value;

    if (typeof noConfilt === 'function') {
      descriptor.value = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
          var response;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return noConfilt.call(this, params);

                case 2:
                  response = _context.sent;
                  this.$$injectable = Object.keys(variables).reduce(function (result, name) {
                    var query = variables[name];
                    var value = get(response, query);
                    Object.assign(result, _defineProperty({}, name, value));
                    return result;
                  }, {});
                  return _context.abrupt("return", response);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    }

    return descriptor;
  };
};